import Icon from '@material-ui/icons/Ballot'; // TODO change
import List from './List';
import Show from './Show';
import Edit from './Edit';

export {
  List,
  Show,
  Edit,
  Icon,
};



// WEBPACK FOOTER //
// ./src/components/EmailTemplates/index.js